import { SearchableSelector, type SearchableOption } from "@/components/searchable-selector";

export function ListFilter({
  label,
  value,
  options,
  onChange,
  emptyLabel = "All",
}: {
  label: string;
  value: string;
  options: SearchableOption[];
  onChange: (value: string) => void;
  emptyLabel?: string;
}): JSX.Element {
  return (
    <div className="flex min-w-0 flex-col gap-1 text-sm [overflow-wrap:anywhere]">
      <span>{label}</span>
      <SearchableSelector label={label} value={value} onChange={onChange}
        options={[{ value: "", label: emptyLabel }, ...options]} />
    </div>
  );
}
